var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Z0g3x Lsal1",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 18 20",
    style: {
      fill: "currentcolor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2c1.379 0 2.5 1.122 2.5 2.5S10.379 7 9 7a2.503 2.503 0 01-2.5-2.5C6.5 3.122 7.622 2 9 2zm0-2a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM9 12.841c3.504 0 6.439 2.462 7.179 5.746a.908.908 0 00.891.697.925.925 0 00.907-1.12C17.046 14.067 13.375 11 9 11S.954 14.067.023 18.164a.926.926 0 00.907 1.12.908.908 0 00.891-.697c.74-3.284 3.675-5.746 7.18-5.746z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user_avatar.cc9946c416114addcc03ec4e6adc5618.svg";
export { ForwardRef as ReactComponent };